__turbopack_context__.v({
  "heroDiscountOffer": "index-module__1dyD7a__heroDiscountOffer",
  "hsaFsaOffer": "index-module__1dyD7a__hsaFsaOffer",
  "tradeInOffer": "index-module__1dyD7a__tradeInOffer",
  "ultraWorkOffer": "index-module__1dyD7a__ultraWorkOffer",
});
